import { render, staticRenderFns } from "./SliderTabs.vue?vue&type=template&id=56080b4a&scoped=true&"
import script from "./SliderTabs.vue?vue&type=script&lang=js&"
export * from "./SliderTabs.vue?vue&type=script&lang=js&"
import style0 from "./SliderTabs.vue?vue&type=style&index=0&id=56080b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56080b4a",
  null
  
)

export default component.exports